import { Component, Input, OnInit } from '@angular/core';

import { forkJoin, Observable } from 'rxjs';
import { map, filter, tap } from 'rxjs/operators';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { SourceChip } from '../../models/source-chip.model';
import { SourceGroup } from '../../models/source-group.model';
import { SourceGroupService } from '../../services/source-group.service';
import { SourceService } from '../../services/source.service';

@Component({
    selector: 'agpr-create-edit-source-group-dialog',
    styleUrls: ['./create-edit-source-group-dialog.component.scss'],
    templateUrl: './create-edit-source-group-dialog.component.html',
    standalone: false
})
export class CreateEditSourceGroupDialogComponent extends AbstractDialogComponent implements OnInit {

    @Input() group: SourceGroup;

    groupNameErrors: string[] = [];
    sourceIds: number[] = [];
    sourceChips: SourceChip[] = [];
    existingSourcesCollapsed: boolean = false;

    editing: boolean = false;

    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        public coreDialogService: CoreDialogService,
        private sourceGroupService: SourceGroupService,
        private sourceService: SourceService
    ) {
        super(coreDialogService, 'CreateEditSourceGroup');
    }

    ngOnInit() {
        if (!!this.group) {
            this.editing = true;
            this.populateSourceChips().subscribe();
        } else {
            this.group = new SourceGroup();
        }
        if (!this.group.sourceIds?.length) {
            this.existingSourcesCollapsed = true;
        }
    }


    private populateSourceChips(): Observable<SourceChip[]> {
        const requests = this.group.sourceIds.map(sourceId => {
            return this.sourceService.getById(sourceId).pipe(
                filter(x => !!x),
                map(source => source.toChipModel())
            );
        });

        return forkJoin(requests).pipe(
            tap(chips => this.sourceChips = chips)
        );
    }

    removeExistingSource(source: SourceChip) {
        this.sourceChips = this.sourceChips.filter(chip => chip !== source);
        this.group.sourceIds = this.group.sourceIds.filter(id => id !== source.id);
    }

    validateGroupName() {
        this.groupNameErrors = [];

        if (!this.group.name.trim()) {
            this.groupNameErrors.push('SourceGroups.error.emptyName');

            return;
        }

        this.sourceGroupService.isNameDuplicated$(this.group.name.trim(), this.group.id).subscribe(isDuplicate => {
            if (isDuplicate) {
                this.groupNameErrors.push('SourceGroups.error.duplicate');
            }
        });
    }

    confirm() {
        this.validateGroupName();
        if (this.groupNameErrors.length === 0) {
            if (this.editing) {
                this.group.sourceIds.push(...this.sourceIds);
                this.sourceGroupService.update(this.group).subscribe();
            } else {
                this.group.sourceIds = this.sourceIds;
                this.sourceGroupService.create(this.group).subscribe();
            }
            this.closeDialog(this.group);
        }
    }

    cancel() {
        this.closeDialog();
    }
}
